<template>
  <b-modal ref="mobile-warning-modal" id="mobile-warning-modal" hide-header hide-footer centered no-close-on-backdrop
    no-close-on-esc hide-header-close :visible="isMobile">
    <div class="mobile-warning-content">
      <div class="icon-warning">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
            fill="#FF6B6B" />
        </svg>
      </div>
      <h3 class="warning-title">Acesso não recomendado</h3>
      <p class="warning-message">
        Esta plataforma não está otimizada para dispositivos móveis e algumas
        funcionalidades podem apresentar limitações.
      </p>
      <p class="warning-message">
        Para uma melhor experiência, recomendamos o uso de um computador ou tablet.
      </p>
      <div class="button-container">
        <button class="btn-continue" @click="closeModal">
          Continuar mesmo assim
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "MobileWarningModal",
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    this.checkIfMobile();
  },
  methods: {
    checkIfMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice =
        /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(
          userAgent.toLowerCase()
        );
      const isSmallScreen = window.innerWidth < 768;
      this.isMobile = isMobileDevice || isSmallScreen;

      if (this.isMobile) {
        document.body.style.overflow = "hidden";
      }
    },
    closeModal() {
      this.isMobile = false;
      document.body.style.overflow = "";
      this.$refs["mobile-warning-modal"].hide();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

::v-deep .modal-dialog {
  max-width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(5px);
  margin: 0;
  padding: 10px;
  box-sizing: border-box;

  .modal-content {
    border-radius: 15px;
    width: 97%;
    margin: 0 auto;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);

    .modal-body {
      padding: 30px 20px;
    }
  }
}

.mobile-warning-content {
  text-align: center;

  .icon-warning {
    margin-bottom: 20px;
    animation: pulse 2s infinite;

    svg {
      width: 64px;
      height: 64px;
    }
  }

  .warning-title {
    color: #ff6b6b;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 20px;
    line-height: 1.3;
  }

  .warning-message {
    color: #333;
    font-size: 16px;
    line-height: 1.2;
    margin-bottom: 20px;
    text-align: center;
  }

  .button-container {
    margin-top: 30px;
  }

  .btn-continue {
    background-color: #ff6b6b;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 12px 30px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #ff5252;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }
}

@media (min-width: 576px) {
  ::v-deep .modal-dialog {
    max-width: 500px;
  }
}
</style>
